import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';

const HeroOverlappedImage = dynamic(() => import('./HeroOverlappedImage'));

export const defaultOptions = {
	firstTopHeader: 'LAWSUIT',
	firstTopSubHeader: 'UBER & LYFT ASSAULT',
	secondTopHeader: 'COMPENSATION POTENTIAL',
	secondTopSubHeader: 'HIGH',
	separationLineColor: 'rgba(255, 255, 255, 0.5)',
	backgroundColor: 'rgba(38, 50, 82, 1)',
	titleColor: 'rgba(255, 255, 255, 1)',
	mainHeaderItems: [
		{ text: 'UBER & LYFT', fontSize: '15.7' },
		{ text: 'ASSAULT', fontSize: '22' },
		{ text: 'LAWSUIT', fontSize: '21.6' },
	],
	backgroundImage:
		'https://cdn.builder.io/api/v1/image/assets%2F039564790efd46a2bd9966880285bc7f%2Fdf16a6cd22a047e8924449cb639dadb5',
} as const;

Builder.registerComponent(HeroOverlappedImage, {
	name: 'HeroOverlappedImage',
	inputs: [
		{
			name: 'firstTopHeader',
			friendlyName: 'First Top Header',
			type: 'text',
			defaultValue: defaultOptions.firstTopHeader,
		},
		{
			name: 'firstTopSubHeader',
			friendlyName: 'First Top Subheader',
			type: 'text',
			defaultValue: defaultOptions.firstTopSubHeader,
		},
		{
			name: 'secondTopHeader',
			friendlyName: 'Second Top Header',
			type: 'text',
			defaultValue: defaultOptions.secondTopHeader,
		},
		{
			name: 'secondTopSubHeader',
			friendlyName: 'Second Top Subheader',
			type: 'text',
			defaultValue: defaultOptions.secondTopSubHeader,
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: defaultOptions.backgroundColor,
		},
		{
			name: 'separationLineColor',
			friendlyName: 'Separation Line Color',
			type: 'color',
			defaultValue: defaultOptions.separationLineColor,
		},
		{
			name: 'titleColor',
			friendlyName: 'Title Color',
			type: 'color',
			defaultValue: defaultOptions.titleColor,
		},
		{
			name: 'mainHeaderItems',
			friendlyName: 'Main Header Items',
			type: 'list',
			defaultValue: [...defaultOptions.mainHeaderItems],
			subFields: [
				{
					name: 'text',
					friendlyName: 'Text',
					type: 'string',
				},
				{
					name: 'fontSize',
					friendlyName: 'Font Size',
					type: 'string',
					helperText:
						'Adjust the font size in decimal increments until its width matches the other sentences.',
				},
			],
			onChange: function (options) {
				if (options.get('mainHeaderItems').length > 3) {
					options.set('mainHeaderItems', options.get('mainHeaderItems').slice(0, 3));
					alert('maximum items is 3, delete items to continue');
				}
			},
		},
		{
			name: 'backgroundImage',
			friendlyName: 'Background Image',
			type: 'file',
			allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
			required: true,
			defaultValue: defaultOptions.backgroundImage,
			helperText: 'Image placed on the right of the heading.',
		},
		{
			name: 'marginBottomMobile',
			friendlyName: 'Margin Bottom (Mobile)',
			type: 'text',
			defaultValue: '0px',
			helperText: 'Margin below the hero on mobile (e.g. 20px, 2rem)',
		},
		{
			name: 'marginBottomDesktop',
			friendlyName: 'Margin Bottom (Desktop)',
			type: 'text',
			defaultValue: '0px',
			helperText: 'Margin below the hero on desktop (e.g. 40px, 3rem)',
		},
	],
	canHaveChildren: true,
	childRequirements: {
		message: 'Child must be a Button.',
		query: { 'component.name': { $eq: 'Button' } },
	},
});
